import React, { useContext, useState, useEffect } from 'react';
import { GithubPicker } from 'react-color'; // Importa el selector de colores
import { ThemeContext } from '../Theme/ThemeContext';

const ColorSwitcher = ({ isOpen }) => {
  const { changeThemeColor } = useContext(ThemeContext);
  const [currentColor, setCurrentColor] = useState('#0062b9'); // Color inicial por defecto

  // Recupera el color desde localStorage al cargar el componente
  useEffect(() => {
    const savedColor = localStorage.getItem('themeColor');
    if (savedColor) {
      setCurrentColor(savedColor); // Establece el color guardado como el actual
      changeThemeColor(savedColor); // Cambia el color principal al guardado
      const [r, g, b] = savedColor.match(/\w\w/g).map((hex) => parseInt(hex, 16)); // Convierte HEX a RGB
      document.documentElement.style.setProperty('--themeClrPrimary-rgb', `${r}, ${g}, ${b}`);
    }
  }, [changeThemeColor]);

  // Maneja el cambio de color
  const handleColorChange = (color) => {
    setCurrentColor(color.hex); // Actualiza el color actual
    changeThemeColor(color.hex); // Cambia el color principal
    localStorage.setItem('themeColor', color.hex); // Guarda el color en localStorage
    const rgb = color.rgb; // Obtén el valor RGB
    document.documentElement.style.setProperty('--themeClrPrimary-rgb', `${rgb.r}, ${rgb.g}, ${rgb.b}`);
  };

  return (
    <div className="color-switcher">
      {isOpen && (
        <div className="color-switcher__menu">
          <GithubPicker
            color={currentColor} // Color actual
            onChange={handleColorChange} // Cambia el color dinámicamente
          />
        </div>
      )}
    </div>
  );
};

export default ColorSwitcher;